module.exports = __webpack_public_path__ + "img/Piranometro.2dba85e0.svg";